export const gastrointestinal = (() => {
    const placeHolderText = 'No abdominal pain, GERD, Black or bloody stools.'

    return placeHolderText
})